export const communicationTypeHash = {
    ApplicationProcedure: 'Application procedure',
    Denominations: 'Denominations',
    Financial: 'Financial',
    LegalProceedings: 'Legal proceedings',
    OtherMatters: 'Other matters',
    TechnicalExamination: 'Technical examination',
    WithdrawalSurrender: 'Withdrawal/Surrender documents',
};
